import { useState, useCallback, useMemo } from 'react';
import {
  useEngineInstance,
  useSubjectId,
  useSubjectAnswers,
  UseSubjectAnswersSelector
} from '@surveycake/react-logic-engine';

const answersSelector: UseSubjectAnswersSelector<string> = answers =>
  (answers.payload[0] as string) || '';

export function useDatePickerAnswer() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { min, max } = useMemo(() => {
    const data = engine.getSubjectData(id);
    return {
      min: data.minMoment,
      max: data.maxMoment
    };
  }, [engine, id]);
  const date = useSubjectAnswers(id, answersSelector);
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(
    () => (setOpen as any)((prevOpen: boolean) => !prevOpen),
    []
  );
  const onChange = useCallback(
    async (newDate?: string) => {
      try {
        await engine.setAnswer(id, { payload: [newDate || ''] });
        const message = engine.getSubjectMessage(id);

        if (!(message && message.error.type) && newDate) {
          setOpen(false);
        }
      } catch (error) {}
    },
    [engine, id]
  );

  return {
    date,
    min,
    max,
    open,
    toggleOpen,
    onChange
  };
}
